<!-- @let c = content; -->
<div
  class="relative p-[10px] border-2 border-solid border-transparent transition-border duration-300 ease-in-out hover:!border-2 hover:!border-solid hover:!border-primary w-[100%] cursor-pointer"
  [id]="'pagemodule' + content.id" [ngStyle]="{
    backgroundColor: styles.colors['other']['background'],
  }" [ngClass]="{
    '!border-2 !border-solid !border-primary': isSelectedModule,
  }">
  <div>
    <div class="text-center font-bold mb-5" [attr.style]="buildStyle('text', filter(
                      items,
                      'type',
                      'text'
                    )[0].styles?.text)">
      {{ filter(items, 'type', 'text')[0].value.text }}
    </div>
    <div>
      <p-stepper [value]="activeStep">
        <p-step-list>
          @for (
          question of filter(items, 'type', 'question');
          track question;
          let i = $index
          ) {
          <p-step [value]="i + 1" [disabled]="!canAccessStep(i + 1)"></p-step>
          }
        </p-step-list>
        <p-step-panels>
          <form (submit)="submitSurvey($event)" #surveyForm>
            @let questions = filter(items, 'type', 'question');
            @for (question of questions; track question; let i = $index) {
            <p-step-panel [value]="i + 1">
              <ng-template #content let-activateCallback="activateCallback">
                <div class="font-bold" [attr.style]="buildStyle('text', question.styles?.question)">
                  {{ question.value.text }}
                </div>
                @for (option of question.value.options; track option; let j = $index) {
                <div class="flex items-center gap-3 rounded-md p-3 my-2"
                  [attr.style]="buildStyle('option', question.styles?.option)">
                  @if (question.value.question_type === 'multiple') {
                    <p-checkbox [inputId]="'option_' + i + '_' + j" [binary]="false" [value]="option"
                      [ngModel]="answers[question.order + '-' + question.value.text] || []"
                      (ngModelChange)="onSelectionChange(question, $event)" [name]="'question_' + i" />
                  } @else {
                    <p-radioButton [inputId]="'option_' + i + '_' + j" [name]="'question_' + question.id" [value]="option"
                      [ngModel]="answers[question.order + '-' + question.value.text]"
                      (ngModelChange)="onSelectionChange(question, $event)" />
                  }
                  <label [for]="'option_' + i + '_' + j">
                    {{ option }}
                  </label>
                </div>
                }

                <div class="flex gap-2 pt-6 justify-end">
                  @if (i + 1 > 1) {
                  <p-button class="w-100 dark" icon="pi pi-arrow-left" [outlined]="true" label="Back"
                    (click)="goToPreviousStep(i + 1, activateCallback)" />
                  }
                  @if (i + 1 < questions.length) {
                  <p-button class="w-100 dark" iconPos="right" icon="pi pi-arrow-right"
                    label="Next" [disabled]="!canMoveToNextStep(i + 1)" (click)="goToNextStep(i + 1, activateCallback)" />
                  }
                  @if (i + 1 === questions.length) {
                    <p-button class="w-100 dark" iconPos="right" icon="pi pi-check" type="submit" label="Submit"
                      [disabled]="!canSubmitSurvey()" />
                  }
                </div>
              </ng-template>
            </p-step-panel>
            }
          </form>
        </p-step-panels>
      </p-stepper>
    </div>
  </div>
</div>